/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Equipment_Quick_HomeInputs */

const en_us2_equipment_quick_home = /** @type {(inputs: Equipment_Quick_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Home basics`)
};

const pt_br2_equipment_quick_home = /** @type {(inputs: Equipment_Quick_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Básico de casa`)
};

const es_419_equipment_quick_home = /** @type {(inputs: Equipment_Quick_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Básico de casa`)
};

const pt_pt2_equipment_quick_home = /** @type {(inputs: Equipment_Quick_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Básico de casa`)
};

const fr_fr2_equipment_quick_home = /** @type {(inputs: Equipment_Quick_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le minimum à la maison`)
};

const de_de2_equipment_quick_home = /** @type {(inputs: Equipment_Quick_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Basics für zu Hause`)
};

const it_it2_equipment_quick_home = /** @type {(inputs: Equipment_Quick_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Base per casa`)
};

/**
* | output |
* | --- |
* | "Home basics" |
*
* @param {Equipment_Quick_HomeInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const equipment_quick_home = /** @type {((inputs?: Equipment_Quick_HomeInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Equipment_Quick_HomeInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_equipment_quick_home(inputs)
	if (locale === "es-419") return es_419_equipment_quick_home(inputs)
	if (locale === "pt-PT") return pt_pt2_equipment_quick_home(inputs)
	if (locale === "fr-FR") return fr_fr2_equipment_quick_home(inputs)
	if (locale === "de-DE") return de_de2_equipment_quick_home(inputs)
	if (locale === "it-IT") return it_it2_equipment_quick_home(inputs)
	return en_us2_equipment_quick_home(inputs)
});
export { equipment_quick_home as "equipment.quick.home" }